module.exports = __webpack_public_path__ + "99c838c51a2ba9e9f71b15a6031bd8ce.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/content/assets/press_teaser_201606_sputnika.jpg
// module id = 647
// module chunks = 0